import axios from "axios";
//getEmployeeBioData
import {
	TRAVEL_LINK_LOADING,
	TRAVEL_LINK_SAVING_FAILED,
	TRAVEL_LINK_SAVING_SUCCESSED,
} from "./types";
export const loadTravelLinkData = (listdata) => (dispatch) => {
	dispatch({ type: TRAVEL_LINK_LOADING });

	let formData = new FormData(); //formdata object
	console.log("loadTravelLinkData data=", listdata);

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(
			listdata.url,
			{
				data: listdata.data,
				opMode: listdata.opMode,
				username: listdata.username,
			},
			config
		)
		.then((response) => {
			dispatch({ type: TRAVEL_LINK_SAVING_SUCCESSED, payload: response });

			console.log("loadTravelLinkData=", response);
		})
		.catch((error) => {
			console.log(error);
			return dispatch({
				type: TRAVEL_LINK_SAVING_FAILED,
				payload: error,
			});
		});
};
